import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { DELETE_URL } from '@utils/api/endpoints.ts';

export const useDeleteGroup = () => {
  const queryClient = useQueryClient();

  const deleteGroup = async (
    customerId: number,
    groupId: number
  ): Promise<void> => {
    await Axios.delete(
      `${DELETE_URL(customerId.toString(), groupId.toString()).groupIam}`
    );
  };

  return useMutation<
    void,
    AxiosError<BaseError>,
    { customerId: number; groupId: number }
  >(({ customerId, groupId }) => deleteGroup(customerId, groupId), {
    onSuccess: (_, { customerId }) => {
      queryClient.invalidateQueries(['customerGroup', customerId]);
    },
    useErrorBoundary: false
  });
};
